import { FlagEmoji, Select } from '@instabox/consumer-web-ui'
import { useRouter } from 'next/router'
import { FC } from 'react'

import useDisplayNames from '../../hooks/useDisplayNames'
import { localeToMarketCode } from '../../utils'

const MarketSelect: FC = () => {
  const { locale, locales, pathname, asPath, query, ...router } = useRouter()

  const [regionNames] = useDisplayNames({ locale, type: 'region' })

  if (!regionNames) {
    // skip market switch for old browsers
    return null
  }

  const markets = locales
    .filter(l => l !== 'default' && !l.startsWith('en-'))
    .map(l => {
      const code = localeToMarketCode(l)
      return {
        locale: l,
        code,
        label: regionNames.of(code?.toUpperCase()),
      }
    })

  const updateLocale = (market: string) => {
    const primaryLocale = locales.find(
      locale => locale.endsWith(market.toUpperCase()) && !locale.startsWith('en-'),
    )
    router.push({ pathname, query }, asPath, {
      locale: primaryLocale,
    })
  }

  return (
    <Select value={localeToMarketCode(locale)} onChange={(_, value) => updateLocale(value)}>
      {markets.map(({ locale, label }) => (
        <option key={locale} value={localeToMarketCode(locale)}>
          <FlagEmoji countryCode={localeToMarketCode(locale)} />
          &#160;&#160;&#160;&#160;&#160;
          {label}
        </option>
      ))}
    </Select>
  )
}

export default MarketSelect
